import { useParams } from 'react-router';

const useRequiredParam = (key: string): string => {
  const params = useParams();
  const value = params[key];
  if (!value) throw new Error(`Missing required route param: ${key}`);
  return value;
};

export default useRequiredParam;
